"use client";
import { getHostURL } from "../helpers/envs";
import { Credentials } from "./config";
import { signIn, useSession } from "next-auth/react";
import { DEFAULT_LOGIN_REDIRECT_PATH } from "../auth/routes";
import { verifyEmail } from "@/app/(auth)/_components/services";

const INVALID_CREDENTIALS_MESSAGE =
  "The phone number or password you entered is incorrect.";

export function useAuthAction() {
  const { data: session } = useSession();
  type AuthActionResult = { ok?: boolean; error?: string } | undefined;
  const signInCompat = signIn as unknown as (
    provider: string,
    options: Record<string, any>,
  ) => Promise<{ ok?: boolean; error?: string } | undefined>;

  async function authenticate(
    credentials: Credentials,
    callbackUrl?: string,
  ): Promise<AuthActionResult> {
    const res = await signInCompat("credentials", {
      ...credentials,
      redirectTo:
        callbackUrl ?? `${getHostURL()}${DEFAULT_LOGIN_REDIRECT_PATH}`,
      redirect: true,
    });
    if (res?.error) {
      switch (res?.error) {
        case "CredentialsSignin":
          return {
            error: INVALID_CREDENTIALS_MESSAGE,
          };
        default:
          return {
            error: "We could not sign you in. Please try again.",
          };
      }
    }
    return res ? { ok: res.ok, error: res.error ?? undefined } : undefined;
  }

  async function authenticateGoogle(
    state: "signup" | "signin",
    callbackUrl?: string,
  ): Promise<AuthActionResult> {
    const res = await signInCompat("google", {
      redirectTo:
        callbackUrl ?? `${getHostURL()}${DEFAULT_LOGIN_REDIRECT_PATH}`,
      redirect: true,
    });
    if (state === "signin") {
      if (session?.email) {
        const { existing } = await verifyEmail(session.email);
        if (!existing || res?.error) {
          return {
            error: INVALID_CREDENTIALS_MESSAGE,
          };
        }
      }
    }
    return res ? { ok: res.ok, error: res.error ?? undefined } : undefined;
  }

  return {
    authenticate,
    authenticateGoogle,
  };
}
